import styled from "styled-components"
import { Container } from "./Container"

export const FlexContainer = styled(Container)`
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: flex-start;
`
